<template>
  <OrgUserList />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
